const DragndropOrder = (containers, config) => {
    const dragHandleSelector = config["dragHandleSelector"] ?? null; // Make whole child element draggable
    const draggableSelector = config["draggableSelector"] ?? null; // Make every child element draggable

    const onDropClbk = config["onDrop"] ?? (() => {}); // Make every child element draggable

    const containerEls = [];
    let elementToMove = null;
    let ghostEl = null;
    let prevDropTarget = null;
    let originalPosition = null;
    let originalPointerEvents = null;

    let autoScrollInterval = null;

    // For moving the element
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let offsetX = 0;
    let offsetY = 0;
    let isDragging = false;
    let currentPointerId = null;
 
    let draggablesInContainer = {}
    const allDraggables = []
    const dragHandles = []


    const init = () => {
        // Get draggable elements in container
        containers.forEach((cont, idx) => {
            const contEl = document.querySelector(cont);
            containerEls.push(contEl);
            const contId = `cont_${idx}`;
            contEl.dataset.dragId = contId;
            let containerDraggables = [];
            if (draggableSelector){ 
                containerDraggables = contEl.querySelectorAll(draggableSelector);
            } else {
                containerDraggables = Array.from(contEl.children);
            }
            draggablesInContainer[contId] = containerDraggables;
            allDraggables.push(...draggablesInContainer[contId]);
        });

        // Get drag handles
        allDraggables.forEach((el, idx) => {
            el.dataset.dragIdx = idx
            let elDrag = el;
            if (dragHandleSelector) {
                elDrag = el.querySelector(dragHandleSelector);
            }
            elDrag.dataset.dragHandleIdx = idx
            dragHandles.push(elDrag)
        });

        dragHandles.forEach((el) => {
            el.addEventListener('pointerdown', dragStart);
            el.classList.toggle("is-draggable", true);
        })
    }

    const dragStart = (e) => {
        e.preventDefault();
        const dragIdx = parseInt(e.currentTarget.dataset.dragHandleIdx);
        elementToMove = allDraggables[dragIdx]
        const style = getComputedStyle(elementToMove);
        originalPosition = style.position;
        originalPointerEvents = style.pointerEvents;

        const rect = elementToMove.getBoundingClientRect();
        const parent = elementToMove.offsetParent || document.body;
        const parentRect = parent.getBoundingClientRect();
        // Get margin values
        const marginTop = parseFloat(style.marginTop);
        const marginLeft = parseFloat(style.marginLeft);

        currentX = 0;
        currentY = 0;
        // Set initial mouse position
        startX = e.clientX;
        startY = e.clientY;

        offsetX = e.clientX - startX;
        offsetY = e.clientY - startY;

        ghostEl = createGhostEl(elementToMove);
        elementToMove.after(ghostEl);
        fixSize(elementToMove);
        elementToMove.style.position = "fixed";
        // elementToMove.style.top = (rect.top - parentRect.top - marginTop) + 'px';
        // elementToMove.style.left = (rect.left - parentRect.left - marginLeft) + 'px';
        elementToMove.style.top = rect.top + window.scrollY + 'px';
        elementToMove.style.left = rect.left + 'px';
        elementToMove.style.zIndex = 10;

        // elementToMove.style.transform = generateTransform(currentX-marginLeft, currentY);
        elementToMove.style.transform = generateTransform(currentX + offsetX, currentY + offsetY - window.scrollY);

        isDragging = true;
        currentPointerId = e.pointerId;
        elementToMove.setPointerCapture(e.pointerId); // Important for mobile

        document.onpointerup = dragEnd;
        document.onpointermove = drag;
        document.onpointercancel = dragCancel;
    }

    const drag = (e) => {
        const isTouch = e.type === 'touchstart';
        e.preventDefault();

        if (!isDragging || e.pointerId !== currentPointerId) return;
        if (e.clientX === 0 && e.clientY === 0) return; // Ignore invalid events
        // Calculate drag offsets
        offsetX = e.clientX - startX;
        offsetY = e.clientY - startY;
        // Update transform with new translation values
        elementToMove.style.transform = generateTransform(currentX + offsetX, currentY + offsetY - window.scrollY);
        const clientY = isTouch ? e.touches[0].clientY : e.clientY;

        // Find what's underneath
        elementToMove.style.pointerEvents = "none"; // Temporarily hide from hit test
        const elementBelow = document.elementFromPoint(e.clientX, e.clientY);
        elementToMove.style.pointerEvents = ""; // Restore

        // Check if it's a valid drop target
        const dropTarget = elementBelow?.closest('[data-drag-idx]');
        if (dropTarget && dropTarget !== elementToMove && dropTarget !== prevDropTarget) {
            prevDropTarget = dropTarget;
            replaceWithGhostEl(dropTarget);
        }
        handleAutoScroll(clientY);
    }

    const dragEnd = (e) => {
        e.preventDefault();
        document.onpointerup = null;
        document.onpointermove = null;

        unfixSize(elementToMove);
        elementToMove.style.position = originalPosition;
        elementToMove.style.pointerEvents = originalPointerEvents;
        elementToMove.style.transform = null;
        elementToMove.style.zIndex = 0;
        elementToMove.style.top = 0;
        elementToMove.style.left = 0;

        if (e.pointerId !== currentPointerId) return;
        elementToMove.releasePointerCapture(e.pointerId);

        // Move the element
        ghostEl.after(elementToMove);
        onDropClbk(elementToMove);

        elementToMove = null;
        ghostEl.remove();
        ghostEl = null;
        isDragging = false;
        cancelAutoScroll();
    }

    const dragCancel = (e) => {
        e.preventDefault();
        document.onpointerup = null;
        document.onpointermove = null;

        unfixSize(elementToMove);
        elementToMove.style.position = originalPosition;
        elementToMove.style.pointerEvents = originalPointerEvents;
        elementToMove.style.transform = null;
        elementToMove.style.zIndex = 0;
        elementToMove.style.top = 0;
        elementToMove.style.left = 0;

        elementToMove = null;
        ghostEl.remove();
        ghostEl = null;
        isDragging = false;
        cancelAutoScroll();
    }

    const replaceWithGhostEl = (el) => {
        let isGhostElBefore = false;
        let sib = el.previousElementSibling;

        while (sib) {
            if(sib == ghostEl) {
                isGhostElBefore = true;
            }
            sib = sib.previousElementSibling;
        }

        if(isGhostElBefore) {
            el.after(ghostEl);
        } else {
            // Default behavior
            el.before(ghostEl);
        }
    }

    const handleAutoScroll = (clientY) => {
        const scrollThreshold = 100; // pixels from edge to trigger scroll
        let scrollSpeed = 4; // pixels per frame
        const viewportHeight = window.innerHeight;

        // Clear any existing auto-scroll
        if (autoScrollInterval) {
            cancelAnimationFrame(autoScrollInterval);
            autoScrollInterval = null;
        }

        // Check if near top edge
        if (clientY < scrollThreshold) {
            autoScrollInterval = requestAnimationFrame(function scroll() {
                scrollSpeed = (scrollThreshold - clientY) / 10;
                window.scrollBy(0, -scrollSpeed);
                if (isAtTop()) return;
                currentY -= scrollSpeed;
                // elementToMove.style.transform = generateTransform(currentX + offsetX, currentY + offsetY);
                autoScrollInterval = requestAnimationFrame(scroll);
            });
        }
        // Check if near bottom edge
        else if (clientY > viewportHeight - scrollThreshold) {
            autoScrollInterval = requestAnimationFrame(function scroll() {
                scrollSpeed = (clientY - (viewportHeight - scrollThreshold)) / 10;
                window.scrollBy(0, scrollSpeed);
                if (isAtBottom()) return;
                currentY += scrollSpeed;
                // elementToMove.style.transform = generateTransform(currentX + offsetX, currentY + offsetY);
                autoScrollInterval = requestAnimationFrame(scroll);
            });
        }
    }

    const cancelAutoScroll = () => {
        if (autoScrollInterval) {
            cancelAnimationFrame(autoScrollInterval);
            autoScrollInterval = null;
        }
    }


    // UTILITY FUNCTIONS

    const generateTransform = (x, y) => {
        return `translate(${x}px, ${y}px) rotate(2deg)`
    }

    const createGhostEl = (originalEl) => {
        const clone = originalEl.cloneNode(true);
        const rect = originalEl.getBoundingClientRect();
        clone.style.width = `${rect.width}px`;
        clone.style.height = `${rect.height}px`;
        clone.style.opacity = "0.3";
        return clone;
    }

    const fixSize = (el) => {
        const rect = el.getBoundingClientRect();
        el.style.width = `${rect.width}px`;
        el.style.height = `${rect.height}px`;
    }

    const unfixSize = (el) => {
        el.style.width = null;
        el.style.height = null;
    }

    const isAtTop = () => {
        return window.scrollY === 0;
    }

    const isAtBottom = () => {
        const scrollPosition = window.scrollY; // Pixels scrolled from top
        const windowHeight = window.innerHeight; // Visible viewport height
        const documentHeight = document.documentElement.scrollHeight; // Total page height

        console.log(scrollPosition + windowHeight, ">=", documentHeight);
        // if (scrollPosition + windowHeight >= documentHeight) console.log("IM AT BOTTOM!!!")
        return scrollPosition + windowHeight >= documentHeight;
    }

    // START
    init();
    // =================
}

export { DragndropOrder };
